/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ agent: NonNullable<unknown> }} Canvas_Versions_By_AgentInputs */



/**
* | output |
* | --- |
* | "Agent {agent}" |
*
* @param {Canvas_Versions_By_AgentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_by_agent = /** @type {((inputs: Canvas_Versions_By_AgentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_By_AgentInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Agent ${i?.agent}`)
	return /** @type {LocalizedString} */ (`Agent ${i?.agent}`)
});